import { get } from 'lodash'

function getConfig (key, defaultValue) {
  return get(window.dataModel, key, defaultValue) || get(window.newBillingConfig, key, defaultValue)
}

export function isEnableEssentialApps () {
  const toggleKey = 'enableEssentialApp'
  return get(window.dataModel, toggleKey, false) || get(window.newBillingConfig, toggleKey, false)
}

export function isProPackageUpdatePhase1 () {
  return getConfig('proPackageUpdatePhase1', false)
}

export function isProPackageUpdatePhase2 () {
  return getConfig('proPackageUpdatePhase2', false)
}